/* eslint-disable indent */
import breakpoints from './breakpoints';
import focusableElements from './focusable-elements';

const hideFocusableElementsinSlide = ($slide) => {
  const $focusableElements = $slide._$$(focusableElements);
  $focusableElements.forEach(($element) =>
    $element.setAttribute('tabindex', '-1')
  );
};

const showFocusableElementsinSlide = ($slide) => {
  const $focusableElements = $slide._$$(focusableElements);
  $focusableElements.forEach(($element) =>
    $element.removeAttribute('tabindex')
  );
};

export const disableFocusOnHiddenSlides = ($slides) => {
  $slides.forEach(hideFocusableElementsinSlide);
  const $selectedSlide = $slides.find(($slide) =>
    $slide.classList.contains('swiper-slide-active')
  );
  showFocusableElementsinSlide($selectedSlide);
};

export const getGenericSliderConfig = (element, heading, textDefault = '') => {
  const slides = element.querySelectorAll('.swiper-slide');
  const pager = element.querySelector('.swiper-pagination');
  const prevButton = element.querySelector('.swiper-button-prev');
  const nextButton = element.querySelector('.swiper-button-next');

  return {
    a11y: {
      enabled: true,
      nextSlideMessage: `Go to ${
        heading
          ? `${heading.textContent
              .replace(/(\r\n|\n|\r)/gm, '')
              .replace(/\s+/g, ' ')
              .trim()}`
          : textDefault
      } next slide`,
      prevSlideMessage: `Go to ${
        heading
          ? `${heading.textContent
              .replace(/(\r\n|\n|\r)/gm, '')
              .replace(/\s+/g, ' ')
              .trim()}`
          : textDefault
      } previous slide`,
      paginationBulletMessage: `Go to ${
        heading
          ? `${heading.textContent
              .replace(/(\r\n|\n|\r)/gm, '')
              .replace(/\s+/g, ' ')
              .trim()}`
          : textDefault
      } slide {{index}} of ${slides.length}`
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true
    },
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    slideToClickedSlide: false,
    observer: true,
    allowTouchMove: true,
    pagination: {
      dynamicBullets: true,
      clickable: true,
      el: pager,
      bulletClass: 'swiper-bullet',
      bulletActiveClass: 'swiper-bullet--active',
      modifierClass: 'swiper-bullet--'
    },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton
    },
    watchOverflow: true
  };
};
